import DeleteGenericModal from "../../modals/DeleteGenericModal";
import ReactTable from "../../util/ReactTable";
import AsyncBlock from "../../components/forms/AsyncBlock";
import PageTitle from "../../components/layout/PageTitle";
import PageSection from "../../components/layout/PageSection";
import Button from "../../components/forms/Button";
import PageContainerFull from "../../components/layout/PageContainerFull";
import {useCallback, useMemo} from "react";
import {FlexLayout} from "../../components/flex/Flex";
import useDeleteModal from "../../modals/useDeleteModal";
import axios from "axios";
import useFetch2 from "../../hooks/useFetch2";
import {Apis} from "../../util/data";
import {useNavigate} from "react-router-dom";
import {format} from "date-fns";
import * as React from "react";

const SinAtencionList = () => {

  const navigate = useNavigate()
  const {loading, data, fetchData, error} = useFetch2(Apis.PROD + '/fecha-sin-atencion/list', []);

  const deleteElement = id => axios.delete(Apis.PROD + '/fecha-sin-atencion/' + id)

  const formatoFecha = 'dd/MM/yyyy HH:mm:ss';

  const {
    wrapper: wrapper1,
    openDeleteModal
  } = useDeleteModal({
    text: '¿Desea eliminar esta fecha sin atencion?',
    action: deleteElement,
    onRefresh: fetchData
  })

  function addFechaSinAtencion() {
    navigate('/sin-atencion/new')
  }

  function editFechaSinAtencion(item) {
    navigate('/sin-atencion/edit/' + item.id)
  }

  const fechaValue = useCallback(cell => {
    const fechaUTC = new Date(cell.renderValue() + new Date().getTimezoneOffset() * 60000);
    return format(fechaUTC, formatoFecha)
  }, []);
  const actionsValue = useCallback(cell =>
      <FlexLayout justifyContent='center'>
        <Button size='xs' variant='light' onClick={() => editFechaSinAtencion(cell.row.original)}>Editar</Button>
        <Button size='xs' variant='danger' onClick={() => openDeleteModal(cell.row.original.id)}>Eliminar</Button>
      </FlexLayout>
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , []);

  const columns = useMemo(
    () => [
      {
        header: 'Consejero',
        accessorKey: 'consejero'
      },
      {
        header: 'Consejeria',
        accessorKey: 'consejeria'
      },
      {
        header: 'Fecha inicio',
        accessorKey: 'fechaInicio',
        cell: fechaValue
      },
      {
        header: 'Fecha fin',
        accessorKey: 'fechaFin',
        cell: fechaValue
      },
      {
        header: 'Motivo',
        accessorKey: 'motivo'
      },
      {
        header: 'Acciones',
        accessorKey: 'id',
        meta: {
          headerClassName: 'text-center', // class para la cabecera
          columnClassName: 'text-center', // class para la columna
        },
        enableSorting: false, // para deshabilitar el sort
        cell: actionsValue
      }
    ]
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , [data]
  )

  return (
    <PageContainerFull>

      <PageSection>
        <PageTitle title={'Fechas sin atención'}/>

        <AsyncBlock loading={loading} error={error}>
          <ReactTable
            columns={columns}
            data={data || []}
            customSearch
            filterAdd={() => addFechaSinAtencion()}
            noData='No existen fechas sin atención'
            pageSize={20}
          />
        </AsyncBlock>
      </PageSection>
      <DeleteGenericModal {...wrapper1} />
    </PageContainerFull>
  )
}

export default SinAtencionList
